<div #body class="detail-page__body">
  <app-quick-nav #quicknav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <div class="event-detail__before-overview" *ngIf="isEventOwner">
    <div class="event-detail__edit-toggle"><app-edit-toggle *ngIf="isEventOwner" class="editSlider"></app-edit-toggle></div>
    <div class="event-detail__admin-button-bar" *ngIf="editModeSet">
      <button class="event-detail__admin-button" mat-raised-button (click)="openDeleteEventDialog()">Delete Event</button>
      <button mat-raised-button (click)="openCloneEventDialog()">Clone Event</button>
    </div>
  </div>

  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div id="overview" class="detail-page__wrapper scroll-spy-section">
        <app-event-overview [aviationEvent]="aviationEvent"></app-event-overview>
      </div>

        <div id="description" class="detail-page__wrapper scroll-spy-section">
          <app-event-description [aviationEvent]="aviationEvent"></app-event-description>
        </div>

        <div *ngIf="editModeSet" class="detail-page__wrapper scroll-spy-section">
          <app-event-short-description [aviationEvent]="aviationEvent"></app-event-short-description>
        </div>

        <div id="location" class="detail-page__wrapper scroll-spy-section">
          <app-event-location [aviationEvent]="aviationEvent" (dataChangedEvent)="dataChanged($event)"></app-event-location>
        </div>

        <div id="details" class="detail-page__wrapper scroll-spy-section">
          <app-event-details [aviationEvent]="aviationEvent" (dataChangedEvent)="dataChanged($event)"></app-event-details>
        </div>

        <div id="contact" class="detail-page__wrapper scroll-spy-section">
          <app-event-contact [aviationEvent]="aviationEvent"></app-event-contact>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="travel">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">AOPA Travel Discounts
                <div><img src="assets/images/PoweredbyFlightBridge.png" width="150" height="16" alt="Powered by FlightBridge"></div>
                <!-- <div class="airport-detail__flightbridge-subtext">Powered by <span class="airport-detail__flightbridge-subtext-name">FlightBridge</span></div> -->
              </h2>
            </div>
            <div class="section__body">
              <app-flightbridge [aviationEvent]="aviationEvent"></app-flightbridge>
            </div>
          </div>
        </div>

        <div id="features" class="detail-page__wrapper scroll-spy-section">
          <app-event-features [aviationEvent]="aviationEvent"></app-event-features>
        </div>

    </div>
    <div class="detail-page__rail">
      <div class="event-detail__review-offensive" *ngIf="!(isFlightDeckAdmin && editModeSet) && (!aviationEvent.interactions || !aviationEvent.interactions.myReportedOffensive); else reportedOffensiveEventPlaceholder"
           (click)="reportOffensive()">Report Offensive</div>
      <div class="event-detail__review-offensive" *ngIf="isFlightDeckAdmin && editModeSet && aviationEvent.interactions && aviationEvent.interactions.reportedOffensive"
           (click)="clearAllOffensive()">Clear User Reports</div>
      <ng-template #reportedOffensiveEventPlaceholder>
        <div *ngIf="!(isFlightDeckAdmin && editModeSet)" class="event-detail__review-offensive" (click)="removeOffensive()">Cancel Report</div>
      </ng-template>

      <div class="detail-page__rail-content" *ngIf="aviationEvent.photos && aviationEvent.photos.length > 0 && aviationEvent.photos[0].previewPhotoPath || editModeSet">
        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Event Photos <mat-icon (click)="openEditImageDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
          </div>
          <div class="event-detail__image-container">
            <ngx-gallery *ngIf="galleryImages && galleryImages.length" [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
          </div>
        </div>
      </div>
      <div class ="event-detail__section-spacer" *ngIf="aviationEvent.photos && aviationEvent.photos.length > 0 && aviationEvent.photos[0].previewPhotoPath || editModeSet"></div>

      <div class="detail-page__rail-content" *ngIf="aviationEvent.location && aviationEvent.location.lat && aviationEvent.location.lon">
        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Event Map</h2>
          </div>
          <div class="section__body">
            <!-- <div class="overview__chart-container"> -->
              <div class="overview__chart-wrapper">
                <agm-map #map class="overview__chart" [zoom]="15"
                         [latitude]="aviationEvent.location.lat"
                         [longitude]="aviationEvent.location.lon"
                         [usePanning]="true"
                         [mapTypeControl]="true" [fullscreenControl]="true"
                         [mapTypeId]="'roadmap'"
                         [mapTypeControlOptions]="{ position: 6, mapTypeIds: [ 'roadmap', 'satellite' ]}" >
                  <agm-marker *ngIf="aviationEvent.location" [latitude]="aviationEvent.location.lat"
                              [longitude]="aviationEvent.location.lon"
                              [markerDraggable]="false"></agm-marker>
                </agm-map>
                <div class="overview__chart-legend">
                  <div>
                    Location is approximate based on street address.
                  </div>
                  <div>
                    <a target="_blank" href="https://www.google.com/maps?saddr=My+Location&daddr={{ directionsURL }}">Get Directions</a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          </div>
        </div>
      </div>

      <div class="event-detail__section-spacer"></div>

      <div class="detail-page__rail-content" *ngIf="aviationEvent.location && aviationEvent.location.lat && aviationEvent.location.lon">
        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Other Nearby Events</h2>
          </div>
          <div class="section__body">
            <app-nearby-events [lat]="aviationEvent.location.lat" [lon]="aviationEvent.location.lon" [eventId]="aviationEvent.eventId"></app-nearby-events>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #noImagePlaceholder>
  <div class="event-detail__image-empty-space">There is currently no image associated with this event.</div>
</ng-template>
